// src/components/DashboardLayout.js
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./APISettings.css";
import Sidebar from "../Layout/Sidebar";
import Topbar from "../Layout/Topbar";
import { ToastContainer, toast } from "react-toastify";
import { useToast } from "../../contexts/ToastContext";
import { apiRequest } from "../../services/api";
import Loader from "../Common/Loader";
import { Card, Breadcrumb } from "react-bootstrap";
import { encryptData } from "../Common/encryptionUtils";
import { faL } from "@fortawesome/free-solid-svg-icons";
import {
  Box,
  Button,
  CardContent,
  Checkbox,
  FormControlLabel,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const APISettings = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const pageLoading = (data) => {
    setLoading(data);
  };

  useEffect(() => {
    // AccessLog("Payroll Configuration");
  }, []);

  const premiseData = (data) => {};

  const authToken = localStorage.getItem("authToken");

  const { toastMessage, clearToast } = useToast();
  const [connectedDetails, setConnectedDetails] = useState(null);
  const [selectedPremise, setSelectedPremise] = useState(
    JSON.parse(localStorage.getItem("selectedTopBarPremises"))
  );

  useEffect(() => {
    if (toastMessage) {
      toast.success(toastMessage);
      clearToast(); // Clear the toast message after displaying it
    }
  }, [toastMessage, clearToast]);

  const customerDetails = JSON.parse(localStorage.getItem("customerDetails"));

  const handlePremiseSelect = (selected) => {
    if (selected?.value) {
      pageLoading(true);
      setSelectedPremise(selected);
      checkConnectedStatus(selected?.value);
    }
  };

  const [apiEnabled, setApiEnabled] = useState(false);
  const [credentialsVisible, setCredentialsVisible] = useState(false);
  const [clientId, setClientId] = useState("");
  const [secretKey, setSecretKey] = useState("");
  const [showClientId, setShowClientId] = useState(false);
  const [showSecret, setShowSecret] = useState(false);

  const checkConnectedStatus = async (premise_id) => {
    pageLoading(true);
    try {
      const headers = { Authorization: `Bearer ${authToken}` };
      const policyResponse = await apiRequest(
        `web_api/admin/getPayrollAPISetting?customer_account_id=${customerDetails?.customerAccountId}&premise_id=${premise_id}`,
        "GET",
        null,
        headers
      );

      if (policyResponse?.data?.status_code === 200) {
        const customer_details = policyResponse.data.data;
        console.log("customer_details--->", customer_details);
        setApiEnabled(customer_details?.status);
        setClientId(customer_details?.client_id || "");
        setSecretKey(customer_details?.secret_key || "");
        if (customer_details.client_id && customer_details.secret_key) {
          setCredentialsVisible(true);
        }
      } else {
        setApiEnabled(false);
        setCredentialsVisible(false);
        console.error(
          "Error: Invalid status code",
          policyResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, { position: "top-right", autoClose: 4000 });
    } finally {
      pageLoading(false);
    }
  };

  // Fetch existing settings on load
  useEffect(() => {
    checkConnectedStatus(selectedPremise?.value);
  }, []);

  const generateRandomKey = (length = 32) => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    return Array.from(
      { length },
      () => chars[Math.floor(Math.random() * chars.length)]
    ).join("");
  };

  const handleShowCredentials = async () => {
    const newClientId = generateRandomKey(24);
    const newSecretKey = generateRandomKey(32);
    console.log("clientId--->", clientId);
    setClientId(newClientId);
    setSecretKey(newSecretKey);
    setCredentialsVisible(true);

    // // Save to backend
    // axios.post("/api/api-settings", {
    //   enabled: true,
    //   client_id: newClientId,
    //   secret_key: newSecretKey,
    // });

    try {
      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const payload = {
        customer_account_id: customerDetails?.customerAccountId,
        premise_id: selectedPremise?.value,
        status: true,
        client_id: newClientId,
        secret_key: newSecretKey,
      };
      const apiResponse = await apiRequest(
        "/web_api/admin/updatePayrollAPISetting",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        toast.success(apiResponse?.data?.message);
      } else {
        toast.error("Invalid response from server");
      }
      console.log("API response", apiResponse.data);
    } catch (error) {
      toast.error("Invalid response from server");
      console.error("Error submitting shifts:", error);
    } finally {
      setLoading(false);
    }
  };

  console.log("credentialsVisible--->", credentialsVisible);

  const handleToggleApi = async (checked) => {
    setApiEnabled(checked);
    // setCredentialsVisible(checked);
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    toast.info("Code copied successfully");
  };

  return (
    <div className="dashboard-layout">
      <Sidebar selectedPremise={selectedPremise} />
      <div className="main-content dashboardMain">
        <Topbar onPremiseSelect={handlePremiseSelect} />
        <ToastContainer />
        {loading && <Loader />}
        <div className="content">
          <div className="contentHeader d-flex align-items-center justify-content-between pb-3">
            <div className="contentDiv">
              {/* <Breadcrumb className="contentTitle">
                <Breadcrumb.Item active>{Title}</Breadcrumb.Item>
                <Breadcrumb.Item active>Time Off Configuration</Breadcrumb.Item>
              </Breadcrumb> */}
              {/* <span className="contentTitle">Report</span> */}
              {/* <span className='contentTitle'>{Title}</span> */}
            </div>
            {/* Search bar on the same row */}
          </div>
          <div className="premiseDetails">
            <div className="row premisesListDiv">
              <div className="row mt-0 g-4">
                <div style={{ textAlign: "center", margin: "0px" }}>
                  <Card
                    sx={{
                      maxWidth: 750,
                      mx: "auto",
                      mt: 5,
                      boxShadow: 4,
                      borderRadius: 3,
                    }}
                  >
                    <CardContent>
                      <Typography variant="h6" gutterBottom>
                        API Settings
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        gutterBottom
                      >
                        Manage API access for your application. Enable API to
                        generate secure credentials.
                      </Typography>

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={apiEnabled}
                            onChange={(e) => handleToggleApi(e.target.checked)}
                          />
                        }
                        label="Enable API"
                      />

                      {apiEnabled && (
                        <Box sx={{ mt: 3 }}>
                          {!credentialsVisible ? (
                            <Button
                              variant="contained"
                              onClick={handleShowCredentials}
                              sx={{ borderRadius: 2, px: 4 }}
                            >
                              Show Credentials
                            </Button>
                          ) : (
                            <Grid container spacing={2}>
                              {/* Client ID */}
                              <Grid item xs={12} md={6}>
                                <TextField
                                  label="Client ID"
                                  value={
                                    showClientId ? clientId : "••••••••••••••••"
                                  }
                                  fullWidth
                                  margin="normal"
                                  InputProps={{
                                    readOnly: true,
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Button
                                          size="small"
                                          variant="outlined"
                                          onClick={() =>
                                            setShowClientId(!showClientId)
                                          }
                                          sx={{ mr: 1 }}
                                        >
                                          {showClientId ? "Hide" : "Show"}
                                        </Button>
                                        <Button
                                          size="small"
                                          variant="outlined"
                                          onClick={() => handleCopy(clientId)}
                                        >
                                          Copy
                                        </Button>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </Grid>

                              {/* Secret Key */}
                              <Grid item xs={12} md={6}>
                                <TextField
                                  label="Secret Key"
                                  value={
                                    showSecret ? secretKey : "••••••••••••••••"
                                  }
                                  fullWidth
                                  margin="normal"
                                  InputProps={{
                                    readOnly: true,
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Button
                                          size="small"
                                          variant="outlined"
                                          onClick={() =>
                                            setShowSecret(!showSecret)
                                          }
                                          sx={{ mr: 1 }}
                                        >
                                          {showSecret ? "Hide" : "Show"}
                                        </Button>
                                        <Button
                                          size="small"
                                          variant="outlined"
                                          onClick={() => handleCopy(secretKey)}
                                        >
                                          Copy
                                        </Button>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </Grid>
                            </Grid>
                          )}
                        </Box>
                      )}
                    </CardContent>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default APISettings;
